import React, { forwardRef, useContext, useState } from "react";
import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import { isMobileContext } from "../../contexts/isMobileContext";
import Image from "next/legacy/image";
import Button from "../common/Button";
import { BASE_URL } from "../../utils/FetchData";
import Magnitizer from "../Animations/Magnitizer";
import FadeIn from "../Animations/FadeIn";
// eslint-disable-next-line react/display-name
const SimilarProjects = forwardRef(({ similarProjects }, ref) => {
	const { isMobile } = useContext(isMobileContext);
	const { locale } = useRouter();
	const [slideNumber, setSlideNumber] = useState(1)
	const [imgHover, setImgHover] = useState(-1)
	return (
		<div className="similar-projects-section" ref={ref}>
			<FadeIn customClass="header">
				<h2 className="light _eleX">{similarProjects?.Header}</h2>
			</FadeIn>
			<FadeIn customClass="projects-container">
				<Swiper
					key={similarProjects?.id}
					style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
					modules={[Navigation, Pagination, Mousewheel]}
					navigation={{
						nextEl: `.swiper-button-next-similar`,
						prevEl: `.swiper-button-prev-similar`,
					}}
					pagination={{
						type: "progressbar",
						el: ".swiper-similar-navigation",
					}}

					onSlideChange={(swiper) => { setSlideNumber((swiper.realIndex + 1)) }}
					slidesPerView={1}
					spaceBetween={20}
					breakpoints={{
						768: {
							slidesPerView: 2,
							spaceBetween: 50,
						},
						1024: {
							slidesPerView: 2,
							spaceBetween: 50,
						},
					}}
				>
					{similarProjects?.Projects?.data.map((project, index) => (
						<SwiperSlide key={index}>
							<div className="project _eleX" key={index}>
								<div className="img-container">
									 <div className="overlay"></div>
									{project?.attributes?.Project_Card?.Img_Desktop?.data?.attributes?.url &&
										<Image
											src={BASE_URL + (isMobile ? project?.attributes?.Project_Card?.Img_Mobile?.data?.attributes?.url : project?.attributes?.Project_Card?.Img_Desktop?.data?.attributes?.url)}
											layout="fill"
											objectFit="cover"
											alt="project_img" />}
									{!isMobile &&
										<>
											<div className='hoverd'>
												<span className='hoverd-items left'></span>
												<span className='hoverd-items right'></span>
												<span className='hoverd-items top'></span>
												<span className='hoverd-items bottom'></span>
											</div>
											<div className="project-details">
												<h3 className="title bold">{project?.attributes?.Project_Card?.Project_Name}</h3>
												<div className="specs">
													{project.attributes.Project_Card?.Project_Info.map((peiceOfInfo, index) => (
														<div className="spec" key={index}>
															<div className="icon-container">
																<Image src={BASE_URL + peiceOfInfo?.Icon?.data?.attributes?.url} layout="fill" objectFit="contain" alt="icon" />
															</div>
															<span className="info">{peiceOfInfo?.Text}</span>
														</div>
													))}
												</div>
												<div className="buttons-container">
													<Button text={project?.attributes?.Project_Card?.Button_Text1} blackStyle link={`/projects/${project?.attributes.Slug}/booking`} nextRoute={project?.attributes.Project_Name} />
													<Button text={project?.attributes?.Project_Card?.Button_Text2} blackStyle link={`/projects/${project?.attributes.Slug}`} nextRoute={project?.attributes.Project_Name} />
												</div>
											</div>
										</>
									}
								</div>
								{isMobile &&
									<div className="project-details-mobile">
										<h3 className="title bold">{project?.attributes?.Project_Card?.Project_Name}</h3>
										<div className="specs">
											{project.attributes.Project_Card?.Project_Info.map((peiceOfInfo, index) => (
												<div className="spec" key={index}>
													<div className="icon-container">
														<Image src={BASE_URL + peiceOfInfo?.Icon?.data?.attributes?.url} layout="fill" objectFit="contain" alt="icon" />
													</div>
													<span className="info">{peiceOfInfo?.Text}</span>
												</div>
											))}
										</div>
										<div className="buttons-container">
											<Button text={project?.attributes?.Project_Card?.Button_Text1} blackStyle link={`/projects/${project?.attributes.Slug}/booking`}/>
											<Button text={project?.attributes?.Project_Card?.Button_Text2} blackBorder link={`/projects/${project?.attributes.Slug}`} nextRoute={project?.attributes.Project_Name} />
										</div>
									</div>}
							</div>
						</SwiperSlide>
					))}
					{similarProjects?.Projects?.data?.length > 2 && <div className="swiper-navigation-continer">
						<div className="navigation-container">
							<div className="slide-number-container bold">
								<div>{slideNumber.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
								{isMobile && <div>{similarProjects?.Projects?.data?.length.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>}
								{!isMobile && <div>{(similarProjects?.Projects?.data?.length - 1).toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>}							</div>
							<div className="swiper-similar-navigation swiper-pagination-progressbar"></div>
						</div>
						<div className="arrows-container">
							<Magnitizer dataDest={1.75}>
								<div className="swiper-button-prev swiper-button-prev-similar similar-arrow black-arrow-prev"
								></div>
							</Magnitizer>
							<Magnitizer dataDest={1.75}>
								<div className="swiper-button-next swiper-button-next-similar  similar-arrow black-arrow-next"
								></div>
							</Magnitizer>
						</div>
					</div>}
				</Swiper>
			</FadeIn>
		</div>
	);
})
export default SimilarProjects
